import {
    ChangeDetectionStrategy,
    Component,
    computed,
    effect,
    inject,
    input,
    signal,
    ViewEncapsulation,
} from '@angular/core';
import {ConfigCardModel} from '../../models/config-card.model';
import {NgComponentOutlet} from '@angular/common';
import {Router} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {ConfigurationService} from '../../services/configuration.service';
import {ConfigAmountBadgesComponent} from '../config-amount-badges/config-amount-badges.component';
import {CardModule} from 'primeng/card';
import {BadgeModule} from 'primeng/badge';
import {TagModule} from 'primeng/tag';
import {TooltipModule} from 'primeng/tooltip';
import {AvatarModule} from 'primeng/avatar';

@Component({
    selector: 'du-config-card',
    imports: [
        TranslatePipe,
        NgComponentOutlet,
        ConfigAmountBadgesComponent,
        CardModule,
        BadgeModule,
        TagModule,
        TooltipModule,
        AvatarModule,
    ],
    templateUrl: './config-card.component.html',
    styleUrl: './config-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class ConfigCardComponent {
    disabled = input(false);
    content = input.required<ConfigCardModel>();

    protected readonly isBadgeHovered = signal(false);
    protected readonly imageError = signal(false);

    private readonly router = inject(Router);
    private readonly defaultLogo = inject(ConfigurationService).configuration.app.defaultLogo;

    protected readonly avatarImage = computed(
        () => this.content().logoUrl || this.defaultLogo || undefined,
    );

    protected readonly useImage = computed(() => {
        return this.avatarImage() && !this.imageError();
    });

    protected readonly avatarLabel = computed(() => {
        const title = this.content().title;
        if (!title) return '?';
        const words = title.trim().split(/\s+/);
        return words.length > 1
            ? (words[0][0] + words[1][0]).toUpperCase()
            : title.substring(0, 2).toUpperCase();
    });

    constructor() {
        effect(() => {
            this.content();
            this.imageError.set(false);
        });
    }

    handleImageError(): void {
        this.imageError.set(true);
    }

    async navigateToRoute(): Promise<void> {
        const {route} = this.content();
        if (route) {
            await this.router.navigate(route.commands, route.extras);
        }
    }
}
